"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require("redux");

var _reactRouterRedux = require("react-router-redux");

var _reduxConnect = require("redux-connect");

var _reduxForm = require("redux-form");

var _ads = require("./ads");

var _ads2 = _interopRequireDefault(_ads);

var _auth = require("./auth");

var _auth2 = _interopRequireDefault(_auth);

var _company = require("./company");

var _company2 = _interopRequireDefault(_company);

var _feedback = require("./feedback");

var _feedback2 = _interopRequireDefault(_feedback);

var _license = require("./license");

var _license2 = _interopRequireDefault(_license);

var _menu = require("./menu");

var _menu2 = _interopRequireDefault(_menu);

var _recommend = require("./recommend");

var _recommend2 = _interopRequireDefault(_recommend);

var _transportDocuments = require("./transportDocuments");

var _transportDocuments2 = _interopRequireDefault(_transportDocuments);

var _userVouchers = require("./userVouchers");

var _userVouchers2 = _interopRequireDefault(_userVouchers);

var _userPickupVouchers = require("./userPickupVouchers");

var _userPickupVouchers2 = _interopRequireDefault(_userPickupVouchers);

var _vouchers = require("./vouchers");

var _vouchers2 = _interopRequireDefault(_vouchers);

var _pickupVouchers = require("./pickupVouchers");

var _pickupVouchers2 = _interopRequireDefault(_pickupVouchers);

var _projects = require("./projects");

var _projects2 = _interopRequireDefault(_projects);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  routing: _reactRouterRedux.routerReducer,
  reduxAsyncConnect: _reduxConnect.reducer,
  form: _reduxForm.reducer,
  feedback: _feedback2.default,
  ads: _ads2.default,
  auth: _auth2.default,
  company: _company2.default,
  license: _license2.default,
  menu: _menu2.default,
  recommend: _recommend2.default,
  transportDocuments: _transportDocuments2.default,
  userVouchers: _userVouchers2.default,
  userPickupVouchers: _userPickupVouchers2.default,
  vouchers: _vouchers2.default,
  pickupVouchers: _pickupVouchers2.default,
  projects: _projects2.default
});
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/reducer.js
 ** module id = 1257
 ** module chunks = 0
 **/